import { Button } from "primereact/button";
import { Trans, useTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";
import React from "react";
import "./CookieConsent.css";
import { CookieConsentProps } from "../types/CookieConsentProps";

export const CookieConsent = ({
    onClickCookiePolicy,
    onReject,
    onAccept,
    onHide,
    visible
}: CookieConsentProps) => {
    const { t } = useTranslation("common");

    const cookieConsentDescription = () => (
        <Trans
            i18nKey={"cookieConsent.description"}
            t={t}
            components={[
                <a
                    className="cookie-policy"
                    key="cookie-policy-link"
                    onClick={onClickCookiePolicy}
                    target="_blank"
                />
            ]}
        />
    );

    const cookieConsentDialogContent = () => (
        <div className="cookie-dialog w-20rem">
            <p className="text-sm text-white">{cookieConsentDescription()}</p>
            <div className="flex flex-column gap-2 mt-3">
                <Button
                    label={getTranslationText("cookieConsent.reject")}
                    onClick={onReject}
                    className="text-sm cookie-button"
                />
                <Button
                    label={getTranslationText("cookieConsent.accept")}
                    onClick={onAccept}
                    className="text-sm cookie-button"
                />
            </div>
        </div>
    );

    const getTranslationText = (key: string) => t(key);

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            position="bottom-right"
            modal={false}
            className="cookie-dialog"
            draggable={false}
            resizable={false}
            closable={false}
            header={getTranslationText("cookieConsent.title")}
            headerClassName="cookie-dialog cookie-header"
            contentClassName="cookie-dialog"
        >
            {cookieConsentDialogContent()}
        </Dialog>
    );
};
